import { LevelSettings, PlayerSettings, DeliveryBonusSettings, ObstacleSettings } from "./LevelSettings";
import { eType as eGameWorldSectionType, SectionInitData } from "./Game World/Sections/Section";
import { RoadInitData } from "./Game World/Sections/Expansions/Road/Road";
import { Settings as RoadLaneSettings } from "./Game World/Sections/Expansions/Road/Settings";
import { BridgeInitData } from "./Game World/Sections/Expansions/Bridge";
import { CarouselInitData } from "./Game World/Sections/Expansions/Carousel/Carousel";
import { BarrierInitData } from "./Game World/Sections/Expansions/Barrier_0";
import { BarrierSettings } from "./Game World/Barrier";
import { NodeList } from "../Utils/Collections/NodeList";
import { RND } from "../Utils/RND";
import { rnd } from "../Game";



export class LevelManager {
    /**
     * Seznam vsech levelu rozdelenych do skupin. [index_skupiny][index_levelu]
     */
    private static _LEVELS: LevelSettings[][];

    /**
     * (RO) Staticky pristup
     */
    static get INSTANCE(): LevelManager { return LevelManager._instance; }
    private static _instance: LevelManager;

    /**
     * Index aktualni skupiny levelu
     */
    private _lvlGroupId: number;

    /**
     * Skupna vybranych levelu. Aktualni je vzdy prni level ve skupine. Po dokonceni levelu, se level ze skupiny odebere.
     */
    private _lvlGroupLevels: NodeList<LevelSettings>;

    /**
     * (RO) Cislo aktualniho levelu (zacina se od 1)
     */
    get lvlNum(): number { return this._lvlNum; }
    private _lvlNum: number;

    /**
     * (RO) Nastaveni pro aktualni level
     */
    get lvlSettings(): LevelSettings { return this._lvlGroupLevels.first; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        LevelManager._instance = this;
        this._lvlGroupLevels = new NodeList<LevelSettings>();

        if (!LevelManager._LEVELS) {
            LevelManager._LEVELS = [
                // Easy
                [
                    // 1
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        10,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0)),
                    // 21
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 1500, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new CarouselInitData(-1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            750, 750),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        11,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 6)),
                    // 22
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new CarouselInitData(-1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            750, 750),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 1500, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        11,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 6)),
                    // 23
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 1500)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        16,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0))
                    /*// 1
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 3000, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 3000, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        10,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0)),
                    // 17
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 3000, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_2)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 0.5, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        10,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0)),
                    // 21
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        11,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 6)),
                    // 22
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        11,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 6)),
                    // 23
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 3000, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(10, 10, 100),
                        // Stin
                        16,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0))*/
                ],
                // Easy+
                [
                    // 2
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 1.1, -1, [4, 2]), new RoadLaneSettings(2500, 3000, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        12,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 10
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 1500, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new CarouselInitData(1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 750),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 1500, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        17,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 6)),
                    // 11
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 1500)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 1500)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 1.1, -1, [4, 2]), new RoadLaneSettings(2500, 3000, 0.65, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        22,
                        // Nastaveni prekazek
                        new ObstacleSettings([11, 6], 0)),
                    // 19
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new CarouselInitData(-1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 750),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 750),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_2)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0)],
                            1.8, 0.5, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        10,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 10)),
                    /*// 2
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 1, -1, [4, 2]), new RoadLaneSettings(2500, 3500, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        12,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 3
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_2),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        17),
                    // 10
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            900, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        17,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 6)),
                    // 11
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(3000, 4000, 1, -1, [4, 2]), new RoadLaneSettings(3000, 4000, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(3000, 4000, 1, 1, [4, 2]), new RoadLaneSettings(3000, 4000, 0.7, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        22,
                        // Nastaveni prekazek
                        new ObstacleSettings([11, 6], 0)),
                    // 19
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_2)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 0.5, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(12, 10, 150),
                        // Stin
                        10,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 10)),*/
                ],
                // Medium
                [
                    // 13
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, -1, [4, 2])]),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 2000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 2000, 2000)]),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_2),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        12,
                        // Nastaveni prekazek
                        new ObstacleSettings([6, 5], 0)),
                    // 12
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new CarouselInitData(1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        15,
                        // Nastaveni prekazek
                        new ObstacleSettings([6, 6], 13)),
                    // 9
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new SectionInitData(eGameWorldSectionType.safeArea_2),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin,
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 10], 0)),
                    // 7
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new CarouselInitData(1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new CarouselInitData(1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 2,
                            0.55, 1, 1,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 25)),
                    // 6
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 1.1, -1, [4, 2]), new RoadLaneSettings(2500, 3000, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 6], 0)),
                    // 5
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2000, 2500, 1, -1, [4, 2]), new RoadLaneSettings(2000, 2500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 1500, 2000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2000, 2500, 1, 1, [4, 2]), new RoadLaneSettings(2000, 2500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 6], 0)),
                    // 4
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1, -1, [4, 2])]),
                        new BridgeInitData(1000, 2000, 3000, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 3000, 3500),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1500, 2000, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0))
                    /*// 4
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 2500, 1, -1, [4, 2])]),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 2500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([7, 7], 0)),
                    // 5
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 1, -1, [4, 2]), new RoadLaneSettings(2500, 3000, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 1, 1, [4, 2]), new RoadLaneSettings(2500, 3000, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 6], 0)),
                    // 6
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 1, -1, [4, 2]), new RoadLaneSettings(2500, 3500, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 6], 0)),
                    // 7
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings(null, 25)),
                    // 9
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new SectionInitData(eGameWorldSectionType.safeArea_2),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin,
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 10], 0)),
                    // 12
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3000, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            900, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 1, 2,
                            900, 1000),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3000, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        15,
                        // Nastaveni prekazek
                        new ObstacleSettings([6, 6], 13)),
                    // 13
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3000, 1, -1, [4, 2])]),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3000, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_2),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(14, 10, 200),
                        // Stin
                        12,
                        // Nastaveni prekazek
                        new ObstacleSettings([6, 5], 0))*/
                ],
                // Hard
                [
                    // 27
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1500, 2000)]),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1750, 2250, 1.1, -1, [4, 2])]),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 2, 3,
                            700, 700),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 1000, 1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 2, 3,
                            700, 700),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(1750, 2250, 1.1, 1, [4, 2])]),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1500, 2000)]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        21,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 6], 6)),
                    // 25
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 1500, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 1500, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1500, 1500)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 2000, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        24,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 24
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3000, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 1500, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 1500, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3000, 1.1, -1, [4, 2]), new RoadLaneSettings(2500, 3000, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 15
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 1500, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2000, 2500, 1, 1, [4, 2]), new RoadLaneSettings(2000, 2500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 1500, 1000, 1500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2000, 2500, 1, 1, [4, 2]), new RoadLaneSettings(2000, 2500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        23,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 8
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 2500, 1.1, 1, [4, 2])]),
                        new BridgeInitData(1000, 2000, 2500, 2500),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 2500, 1.1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 2500, 1.1, -1, [4, 2])]),
                        new BridgeInitData(1000, 2000, 2500, 2500),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2000, 2500, 1.1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        22,
                        // Nastaveni prekazek
                        new ObstacleSettings([8, 8], 0))
                    /*// 8
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(3000, 3800, 1, 1, [4, 2])]),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(3000, 3800, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(3500, 3800, 1, -1, [4, 2])]),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(3500, 3800, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        22,
                        // Nastaveni prekazek
                        new ObstacleSettings([8, 8], 0)),
                    // 15
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 1, 1, [4, 2]), new RoadLaneSettings(2500, 3500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 1, 1, [4, 2]), new RoadLaneSettings(2500, 3500, 1, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        23,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 24
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 0.7, 1, [4, 2]), new RoadLaneSettings(2500, 3500, 1, 1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new RoadInitData(eGameWorldSectionType.road2, [new RoadLaneSettings(2500, 3500, 1, -1, [4, 2]), new RoadLaneSettings(2500, 3500, 0.7, -1, [4, 2])]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        19,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 25
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1000, 2000)]),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        24,
                        // Nastaveni prekazek
                        new ObstacleSettings([12, 6], 0)),
                    // 27
                    new LevelSettings([
                        new SectionInitData(eGameWorldSectionType.topVan),
                        new SectionInitData(eGameWorldSectionType.safeArea_0),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1500, 2500)]),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3500, 1, -1, [4, 2])]),
                        new CarouselInitData(1,
                            0.55, 1, 1,
                            0.55, 2, 3,
                            1000, 1000),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_1),
                        new BridgeInitData(1000, 2000, 2500, 3500),
                        new SectionInitData(eGameWorldSectionType.parcelCollection_0),
                        new CarouselInitData(-1,
                            0.55, 1, 1,
                            0.55, 2, 3,
                            1000, 1000),
                        new RoadInitData(eGameWorldSectionType.road1, [new RoadLaneSettings(2500, 3500, 1, 1, [4, 2])]),
                        new BarrierInitData(eGameWorldSectionType.barrier_0, [new BarrierSettings(1000, 1500, 1500, 2500)]),
                        new SectionInitData(eGameWorldSectionType.safeArea_1),
                        new SectionInitData(eGameWorldSectionType.botVan)],
                        // Nastaveni hrace
                        new PlayerSettings(
                            [new pc.Vec2(0, 0.3), new pc.Vec2(-0.18, 0), new pc.Vec2(0.18, 0)],
                            1.8, 1.8, 1.8, 1),
                        // Nastaveni bonusu za doruceni baliku
                        new DeliveryBonusSettings(16, 10, 250),
                        // Stin
                        21,
                        // Nastaveni prekazek
                        new ObstacleSettings([10, 6], 6)),*/
                ]
            ];
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._lvlNum = 1;
        this._lvlGroupId = 0;
        this.prepareLvlGroup();
    }

    //-------------------------------------------------------------------------
    /**
     * Prechod do dalsiho levelu
     */
    //-------------------------------------------------------------------------
    goToNextLevel(): void {
        this._lvlNum++;
        this._lvlGroupLevels.removeById(0);

        if (this._lvlGroupLevels.empty) {
            // Prechod do dalsi skupiny levelu
            if (this._lvlGroupId + 1 < LevelManager._LEVELS.length)
                this._lvlGroupId++;

            this.prepareLvlGroup();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private prepareLvlGroup(): void {
        let group = LevelManager._LEVELS[this._lvlGroupId];

        // Kolik levelu se pouzije
        let lvlPerGroup = (this._lvlGroupId != LevelManager._LEVELS.length - 1 ? 1 : LevelManager._LEVELS[this._lvlGroupId].length);

        if (lvlPerGroup > group.length)
            lvlPerGroup = group.length;

        // Vybrat levely ze skupiny        
        let selLvlMask = 0;

        this._lvlGroupLevels.clear();

        while (lvlPerGroup != 0) {
            let i = rnd.randomIntIn(0, group.length - 1);

            while ((selLvlMask & (1 << i)) != 0) {
                if (++i == group.length)
                    i = 0;
            }

            this._lvlGroupLevels.add(group[i]);

            selLvlMask |= (1 << i);
            lvlPerGroup--;
        }
    }
}